"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checks = void 0;
const coded_error_1 = require("./coded-error");
class Checks {
    /**
     * Verifies that a boolean condition is met or throws an Error if it is not.
     *
     * @param checkResult Determines the outcome of the check via it's truthyness.
     * @param subjectOfCheck The error message if `checkResult` is falsy.
     * @param code The code of the error if `checkResult is falsy.
     */
    static truthy(checkResult, subjectOfCheck = "variable", code = "-1") {
        if (!checkResult) {
            const message = `"${subjectOfCheck}" is falsy, need a truthy value.`;
            throw new coded_error_1.CodedError(message, code);
        }
    }
    /**
     * Verifies that a string is indeed not a blank string.
     * Blank string can be one that only has whitespace characters for example.
     *
     * @param value The value that will be asserted for being a non-blank string.
     * @param subject The error message if `value` is a blank string.
     * @param code The code of the error if `checkResult is falsy.
     */
    static nonBlankString(value, subject = "variable", code = "-1") {
        if (typeof value !== "string" || value.trim().length === 0) {
            const message = `"${subject}" is a blank string. Need non-blank.`;
            throw new coded_error_1.CodedError(message, code);
        }
    }
}
exports.Checks = Checks;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hlY2tzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21haW4vdHlwZXNjcmlwdC9jaGVja3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsK0NBQTJDO0FBRTNDLE1BQWEsTUFBTTtJQUNqQjs7Ozs7O09BTUc7SUFDSSxNQUFNLENBQUMsTUFBTSxDQUNsQixXQUFnQixFQUNoQixpQkFBeUIsVUFBVSxFQUNuQyxPQUFlLElBQUk7UUFFbkIsSUFBSSxDQUFDLFdBQVcsRUFBRTtZQUNoQixNQUFNLE9BQU8sR0FBRyxJQUFJLGNBQWMsa0NBQWtDLENBQUM7WUFDckUsTUFBTSxJQUFJLHdCQUFVLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxDQUFDO1NBQ3JDO0lBQ0gsQ0FBQztJQUVEOzs7Ozs7O09BT0c7SUFDSSxNQUFNLENBQUMsY0FBYyxDQUMxQixLQUFVLEVBQ1YsVUFBa0IsVUFBVSxFQUM1QixPQUFlLElBQUk7UUFFbkIsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLElBQUksS0FBSyxDQUFDLElBQUksRUFBRSxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7WUFDMUQsTUFBTSxPQUFPLEdBQUcsSUFBSSxPQUFPLHNDQUFzQyxDQUFDO1lBQ2xFLE1BQU0sSUFBSSx3QkFBVSxDQUFDLE9BQU8sRUFBRSxJQUFJLENBQUMsQ0FBQztTQUNyQztJQUNILENBQUM7Q0FDRjtBQXJDRCx3QkFxQ0MifQ==